import React from 'react';
import { Routes, Route } from 'react-router-dom';

import AuthProvider from './authentication/AuthProvider';
import RequireAuth from './authentication/RequireAuth';

import LoginPage from './screens/auth/LoginPage';
import MainLayout from './screens/MainLayout';

import WorkspaceHome from './screens/main/WorkspaceHome';
import CompaniesPage from './screens/main/CompaniesPage';
import CompanyDetailPage from './screens/main/CompanyDetailPage';
import DepartmentsPage from './screens/main/DepartmentsPage';
import DesignationsPage from './screens/main/DesignationsPage';
import ServicesPage from './screens/main/ServicesPage';
import UsersPage from './screens/main/UsersPage';
import StaffDetailPage from './screens/main/StaffDetailPage';
import LeadsPage from './screens/main/LeadsPage';
import LeadDetailPage from './screens/main/LeadDetailPage';
import AssociatesPage from './screens/main/AssociatesPage';
import ClientsPage from './screens/main/ClientsPage';
import ClientDetailPage from './screens/main/ClientDetailPage';
import VatSetupPage from './screens/main/VatSetupPage';
import VatReportsPage from './screens/main/VatReportsPage';
import ScanNReadPage from './screens/main/ScanNReadPage';
import DeadlinesPage from './screens/main/DeadlinesPage';
import ProjectsPage from './screens/main/ProjectsPage';
import TasksPage from './screens/main/TasksPage';
import TaskDetailPage from './screens/main/TaskDetailPage';
import ProposalsPage from './screens/main/ProposalsPage';
import EngagementsPage from './screens/main/EngagementsPage';
import TimesheetsPage from './screens/main/TimesheetsPage';
import ChartOfAccountsPage from './screens/main/ChartOfAccountsPage';
import InvoicesPage from './screens/main/InvoicesPage';
import InvoiceDetailPage from './screens/main/InvoiceDetailPage';
import PaymentsPage from './screens/main/PaymentsPage';
import CreditNotesPage from './screens/main/CreditNotesPage';
import PortalHome, { PortalStatement } from './screens/portal/PortalHome';
import JournalPage from './screens/main/JournalPage';
import LedgerReportsPage from './screens/main/LedgerReportsPage';
import BranchesPage from './screens/main/BranchesPage';
import FixedAssetsPage from './screens/main/FixedAssetsPage';
import BooksPage from './screens/main/BooksPage';
import CounterpartiesPage from './screens/main/CounterpartiesPage';
import BudgetsPage from './screens/main/BudgetsPage';
import PerformancePage from './screens/main/PerformancePage';
import WorkbookPage from './screens/main/WorkbookPage';
import EngagementLettersPage from './screens/main/EngagementLettersPage';
import EngagementLetterDetailPage from './screens/main/EngagementLetterDetailPage';
import AccountPage from './screens/main/AccountPage';
import NotFoundPage from './screens/NotFoundPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route
            path="/"
            index
            element={
              <RequireAuth>
                <WorkspaceHome />
              </RequireAuth>
            }
          />
          <Route
            path="/portal"
            element={
              <RequireAuth>
                <PortalHome />
              </RequireAuth>
            }
          />
          <Route
            path="/portal/statement"
            element={
              <RequireAuth>
                <PortalStatement />
              </RequireAuth>
            }
          />
          <Route
            path="/companies"
            element={
              <RequireAuth>
                <CompaniesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/companies/:id"
            element={
              <RequireAuth>
                <CompanyDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="/departments"
            element={
              <RequireAuth>
                <DepartmentsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/designations"
            element={
              <RequireAuth>
                <DesignationsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/services"
            element={
              <RequireAuth>
                <ServicesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/users"
            element={
              <RequireAuth>
                <UsersPage />
              </RequireAuth>
            }
          />
          <Route
            path="/users/:id"
            element={
              <RequireAuth>
                <StaffDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="/leads"
            element={
              <RequireAuth>
                <LeadsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/leads/:id"
            element={
              <RequireAuth>
                <LeadDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="/associates"
            element={
              <RequireAuth>
                <AssociatesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/clients"
            element={
              <RequireAuth>
                <ClientsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/clients/:id"
            element={
              <RequireAuth>
                <ClientDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="/vat-setup"
            element={
              <RequireAuth>
                <VatSetupPage />
              </RequireAuth>
            }
          />
          <Route
            path="/vat-reports"
            element={
              <RequireAuth>
                <VatReportsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/scan-n-read"
            element={
              <RequireAuth>
                <ScanNReadPage />
              </RequireAuth>
            }
          />
          <Route
            path="/deadlines"
            element={
              <RequireAuth>
                <DeadlinesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/projects"
            element={
              <RequireAuth>
                <ProjectsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/tasks"
            element={
              <RequireAuth>
                <TasksPage />
              </RequireAuth>
            }
          />
          <Route
            path="/tasks/:id"
            element={
              <RequireAuth>
                <TaskDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="/proposals"
            element={
              <RequireAuth>
                <ProposalsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/engagements"
            element={
              <RequireAuth>
                <EngagementsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/timesheets"
            element={
              <RequireAuth>
                <TimesheetsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/chart-of-accounts"
            element={
              <RequireAuth>
                <ChartOfAccountsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/invoices"
            element={
              <RequireAuth>
                <InvoicesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/invoices/:id"
            element={
              <RequireAuth>
                <InvoiceDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="/payments"
            element={
              <RequireAuth>
                <PaymentsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/journal"
            element={
              <RequireAuth>
                <JournalPage />
              </RequireAuth>
            }
          />
          <Route
            path="/ledger-reports"
            element={
              <RequireAuth>
                <LedgerReportsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/branches"
            element={
              <RequireAuth>
                <BranchesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/workbook"
            element={
              <RequireAuth>
                <WorkbookPage />
              </RequireAuth>
            }
          />
          <Route
            path="/reports"
            element={
              <RequireAuth>
                <PerformancePage />
              </RequireAuth>
            }
          />
          <Route
            path="/budgets"
            element={
              <RequireAuth>
                <BudgetsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/counterparties"
            element={
              <RequireAuth>
                <CounterpartiesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/books"
            element={
              <RequireAuth>
                <BooksPage />
              </RequireAuth>
            }
          />
          <Route
            path="/fixed-assets"
            element={
              <RequireAuth>
                <FixedAssetsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/credit-notes"
            element={
              <RequireAuth>
                <CreditNotesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/engagement-letters"
            element={
              <RequireAuth>
                <EngagementLettersPage />
              </RequireAuth>
            }
          />
          <Route
            path="/engagement-letters/:id"
            element={
              <RequireAuth>
                <EngagementLetterDetailPage />
              </RequireAuth>
            }
          />
          <Route
            path="/account"
            element={
              <RequireAuth>
                <AccountPage />
              </RequireAuth>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
